import { apis } from './defaults/apis.esm.js';
import { components } from './defaults/components.esm.js';
import { icons } from './defaults/icons.esm.js';
import { themes } from './defaults/themes.esm.js';
import { createSpecializedApp } from '@backstage/core-app-api';

function createApp(options) {
  return createSpecializedApp({
    ...options,
    apis: options?.apis ?? [],
    bindRoutes: options?.bindRoutes,
    components: {
      ...components,
      ...options?.components
    },
    configLoader: options?.configLoader,
    defaultApis: apis,
    icons: {
      ...icons,
      ...options?.icons
    },
    plugins: options?.plugins ?? [],
    featureFlags: options?.featureFlags ?? [],
    themes: options?.themes ?? themes
  });
}

export { createApp };
//# sourceMappingURL=createApp.esm.js.map
